import classNames from 'classnames';
import type { ReactNode } from 'react';
import React from 'react';
import * as styles from './OneColumnPage.module.scss';

type OneColumnPageProps = {
  children: ReactNode;
  hasBanner?: boolean;
};

const OneColumnPage = ({ hasBanner, children }: OneColumnPageProps) => (
  <div
    className={classNames(styles.container, { [styles.hasBanner]: hasBanner })}
  >
    <div className={styles.content}>{children}</div>
  </div>
);

export default OneColumnPage;
